import React from 'react';
import PropTypes from 'prop-types';
import Link from '@/Fi16100/Components/Link';

function FooterLink(props) {
	const linkClassName = 'link-white text-decoration-none'
		+ (props.header ? ' text-uppercase fw-bold' : '');

	return (
		<div className={(props.className ?? '') + (props.header ? ' mb-2' : 'mb-1')}>
			{props.external
				?
				<a href={props.href} className={linkClassName}>
					{props.children}
				</a>
				:
				<Link href={props.href} className={linkClassName}>
					{props.children}
				</Link>
			}
		</div>
	);
}

FooterLink.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string.isRequired,
	header: PropTypes.bool,
	external: PropTypes.bool,
	children: PropTypes.node
};

export default FooterLink;
